module.exports = __webpack_public_path__ + "static/media/cuperhidro.d6530deb.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/climasense/xanthomonas_pimiento/preventiva/cuperhidro.png
// module id = 1448
// module chunks = 3